import React from "react"
import {RootState} from "../../../rootReducer"
import {Grid, GridColumn} from "@progress/kendo-react-grid"
import {useAppSelector} from "../../../store"
import {SpinnerGrid} from "../../../shared/CommonItems"

const AxleGrid = () => {
    const axleData = useAppSelector((state: RootState) => state.containers.dvsaTest.axleData)
    const axleloading = useAppSelector((state: RootState) => state.containers.dvsaTest.axleLoading)
    return (
        <div className="position-relative">
            {axleloading && <SpinnerGrid />}
            <Grid
                data={axleData}
                style={{
                    height: "calc(((100vh - 14rem) * 0.33) - 25px)",
                }}
            >
                <GridColumn field="axleCode" title="Axle Code" />
                <GridColumn field="axleName" title="Axle" />
            </Grid>
        </div>
    )
}

export default AxleGrid
